import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ErrorHandlingService } from '../../services/errorHandling/error-handling.service';
import { FilterTextsPipe } from '../../pipes/filterTexts/filterTexts.pipe';
import { EEntityType, ERelationType } from '@web/dtos';
import { LanguagePipe } from '../../pipes/language/language.pipe';
import { WebTextStore } from '../../services/api/text/web-text-store.service';

@Component({
  selector: 'aw-error-page',
  imports: [CommonModule, RouterLink, FilterTextsPipe, LanguagePipe],
  templateUrl: './error-page.component.html',
  styles: ``,
})
export class ErrorPageComponent {
  public readonly errorHandlingService: ErrorHandlingService =
    inject(ErrorHandlingService);
  protected readonly textStore: WebTextStore = inject(WebTextStore);
  private readonly route: ActivatedRoute = inject(ActivatedRoute);

  protected readonly ERelationType: typeof ERelationType = ERelationType;
  protected readonly EEntityType: typeof EEntityType = EEntityType;

  protected errorsFromUrl: string[] = Object.keys(
    this.route.snapshot.queryParams
  ).map(key => {
    return `${key}: ${this.route.snapshot.queryParams[key]}`;
  });
}
